import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllAudioLanguageSlice = createSlice({
  name: "getAllAudioLanguage",
  initialState: { data: null, success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data } = action.payload;
      state.data = data;
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllAudioLanguageSlice;
const getAllAudioLanguageAction = createAction(name);

export {
  getAllAudioLanguageAction,
  actions as getAllAudioLanguageActions,
  reducer as getAllAudioLanguageReducer,
};
